module.exports = __webpack_public_path__ + "img/no-date.c0738c68.png";